import { Column } from '@app/modules/table/classes/column.class';
import { CellDisplay } from '@app/modules/table/enums/cell-display.enum';

export class ExtensionColumn extends Column {
    title = 'payroll.settings.extension';
    property = 'extension';
    sortable = false;
    type: CellDisplay = CellDisplay.string;
}
